import styled from 'styled-components';

export default styled.div`
  && {
    width: 100%;
    padding: 40px 65px;
    .exclamation {
      margin-right: 4px;
      margin-bottom: 20px;
    }
    .※ {
      color: rgba(255, 0, 0, 1);
      height: 18px;
      width: 12px;
      margin-right: 4px;
    }
    .form {
      background-color: rgba(238, 238, 238, 1);
      padding: 40px 30px;
    }
    .space {
      margin-right: 3px;
    }
    .titleInput {
      display: flex;
      align-items: center;
      margin-top: 8px;
    }
    .date {
      margin: 5px 5px 24px 5px;
    }
    .ant-input-search-button {
      background-color: #ff8a00;
      color: white;
      border: none;
    }
    .submit {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-top: 30px;
      margin-bottom: 30px;
      .text {
        text-align: center;
        margin-bottom: 20px;
      }
      .btn {
        width: 240px;
        height: 60px;
      }
    }
    .ant-tooltip-inner {
      color: black;
    }
    .ant-btn {
      :hover {
        background: white;
        border: 1px solid rgba(235, 164, 80, 1);
        color: rgba(235, 164, 80, 1);
      }
    }
  }
`;
